<template>
  <card>
    <template slot="header">
      <div class="d-flex justify-content-between">
        <h4 class="card-title">Stammdaten</h4>
        <button type="submit" class="btn btn-fill btn-primary"
          @click="$router.push(`/suppliers/${supplier.id}/edit`)"
        >
          Bearbeiten
        </button>
      </div>
    </template>
    <fg-input label="Name">
      <p class="form-control-static">{{ supplier.name }}</p>
    </fg-input>
    <fg-input label="Kundennummer">
      <p class="form-control-static">{{ supplier.customer_number }}</p>
    </fg-input>
    <fg-input label="E-Mail Adresse">
      <p class="form-control-static">{{ supplier.email }}</p>
    </fg-input>
    <fg-input label="Telefonnummer">
      <p class="form-control-static">{{ supplier.phone }}</p>
    </fg-input>
    <fg-input label="Straße">
      <p class="form-control-static">{{ supplier.street }}</p>
    </fg-input>
    <div class="row">
      <div class="col-sm-3">
        <fg-input label="PLZ">
          <p class="form-control-static">{{ supplier.zip }}</p>
        </fg-input>
      </div>
      <div class="col-sm-9">
        <fg-input label="Ort">
          <p class="form-control-static">{{ supplier.place }}</p>
        </fg-input>
      </div>
    </div>
    <fg-input label="Land">
      <p class="form-control-static">{{ supplier.country }}</p>
    </fg-input>
    <div class="row">
      <div class="col-sm-9">
        <fg-input label="IBAN">
          <p class="form-control-static">{{ supplier.iban }}</p>
        </fg-input>
      </div>
      <div class="col-sm-3">
        <fg-input label="BIC">
          <p class="form-control-static">{{ supplier.bic }}</p>
        </fg-input>
      </div>
    </div>
    <fg-input label="Mindestbestellwert">
      <p class="form-control-static">{{ supplier.min_order_sum }}</p>
    </fg-input>
    <fg-input label="Webshop">
      <p class="form-control-static">{{ supplier.webshop }}</p>
    </fg-input>
    <fg-input label="Homepage">
      <p class="form-control-static">{{ supplier.homepage }}</p>
    </fg-input>
    <fg-input label="Username">
      <p class="form-control-static">{{ supplier.username }}</p>
    </fg-input>
    <fg-input label="Passwort">
      <p class="form-control-static">{{ supplier.password }}</p>
    </fg-input>
    <fg-input label="Letzt Bestellung am">
      <p class="form-control-static">{{ supplier.last_order | date }}</p>
    </fg-input>
    <fg-input label="Kommentar">
      <p class="form-control-static" style="white-space: break-spaces;">{{ supplier.comment }}</p>
    </fg-input>
  </card>
</template>

<script>
export default {
  props: ['supplier']
}
</script>

<style>
</style>
